<form [formGroup]="clinicFormGroup">
  <div class="help">
    {{ 'clinics.popup.help' | translate }}
  </div>

  <div class="flex-row">
    <mat-form-field class="zip-code" appearance="outline">
      <mat-label>{{'clinics.popup.postal_code' | translate}}</mat-label>
      <input formControlName="zipCode" matInput required>
      <mat-error *ngIf="clinicFormGroup.get('zipCode')?.hasError('required')">{{'clinics.popup.err_postal_code_required' | translate}}</mat-error>
      <mat-error *ngIf="clinicFormGroup.get('zipCode')?.hasError('pattern')">{{'clinics.popup.err_postal_code_pattern' | translate}}</mat-error>
    </mat-form-field>

    <app-autocomplete-selector
      [clearButton]="true"
      [requiredErrorMessage]="'clinics.popup.clinic_name_required' | translate"
      [label]="'clinics.popup.clinic_name' | translate"
      [itemCtrl]="textSearchFormControl"
      [filter]="onFilterClinics"
      [isRequired]="true"
      (selectItemChanged)="onSelectedUserClinicChanged($event)">
    </app-autocomplete-selector>
  </div>
</form>
